import {Column} from 'react-table'
import {RelatedFiles} from '../../core/_models'
import {RelatedFilesActionsCell} from './RelatedFilesActionsCell'
import {RelatedFilesCustomHeader} from './RelatedFilesCustomHeader'
import {RelatedFilesDescription} from './RelatedFilesDescription'

const RelatedFilesColumns: ReadonlyArray<Column<RelatedFiles>> = [
  //HEADER COLUMN - Conditioning TYPE
  {
    Header: (props) => (
      <RelatedFilesCustomHeader
        tableProps={props}
        title='COMMON.DESCRIPTION'
        className='fs-8 min-w-600px text-center flex-row-fluid flex-center'
      />
    ),
    id: 'description',
    Cell: ({...props}) => <RelatedFilesDescription RelatedFiles={props.data[props.row.index]} />,
  },

  //HEADER COLUMN - ACTIONS
  {
    Header: (props) => (
      <RelatedFilesCustomHeader
        tableProps={props}
        title='MENU.ACTIONS'
        className='fs-8 min-w-150px flex-row-fluid flex-center'
      />
    ),
    id: 'actions',
    Cell: ({...props}) => <RelatedFilesActionsCell RelatedFiles={props.data[props.row.index]} />,
  },
]

export {RelatedFilesColumns}
